var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEspiral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 99,
    rx: 4.5,
    fill: "white",
    stroke: "transparent"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.76628 50.4397C9.77778 50.4397 10.5696 50.8659 11.1418 51.7183C11.7139 52.5651 12 53.7282 12 55.2075C12 56.7308 11.7037 57.9103 11.1111 58.7462C10.5236 59.5821 9.72158 60 8.70498 60C7.6986 60 6.90932 59.6068 6.33716 58.8204H6.17625L5.78544 59.835H4V47H6.33716V49.986C6.33716 50.3655 6.30651 50.9731 6.24521 51.809H6.33716C6.88378 50.8962 7.69349 50.4397 8.76628 50.4397ZM8.01533 52.4524C7.43806 52.4524 7.0166 52.6449 6.75096 53.0298C6.48531 53.4093 6.34738 54.0389 6.33716 54.9188V55.191C6.33716 56.1808 6.47254 56.8902 6.74329 57.3192C7.01916 57.7481 7.45338 57.9626 8.04598 57.9626C8.52618 57.9626 8.90677 57.7261 9.18774 57.2532C9.47382 56.7747 9.61686 56.0819 9.61686 55.1745C9.61686 54.2671 9.47382 53.588 9.18774 53.1371C8.90166 52.6806 8.51086 52.4524 8.01533 52.4524Z",
    fill: "#005AE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2909 49.8277L94.8175 48.5185H94.7533C94.3414 49.0755 93.9161 49.4631 93.4774 49.6813C93.0441 49.8938 92.4771 50 91.7763 50C90.9151 50 90.2357 49.7359 89.7382 49.2076C89.2461 48.6793 89 47.9271 89 46.9509C89 45.9288 89.3317 45.1766 89.995 44.6942C90.6637 44.2061 91.6693 43.9363 93.012 43.8846L94.5687 43.8329V43.4109C94.5687 42.4347 94.1033 41.9466 93.1725 41.9466C92.4557 41.9466 91.6132 42.1792 90.6449 42.6443L89.8345 40.8699C90.8669 40.29 92.0117 40 93.2688 40C94.4724 40 95.3952 40.2814 96.0371 40.8441C96.679 41.4068 97 42.2624 97 43.4109V49.8277H95.2909ZM94.5687 45.3661L93.6219 45.4005C92.9104 45.4235 92.3808 45.5613 92.0331 45.814C91.6854 46.0666 91.5115 46.4513 91.5115 46.9681C91.5115 47.7089 91.9074 48.0792 92.6991 48.0792C93.2661 48.0792 93.7182 47.9041 94.0552 47.5538C94.3975 47.2036 94.5687 46.7384 94.5687 46.1585V45.3661Z",
    fill: "#008746"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0736 81C48.3579 81 47 79.352 47 76.0561C47 74.4167 47.3694 73.1657 48.1081 72.3028C48.8469 71.4343 49.9056 71 51.2843 71C52.2936 71 53.1988 71.2186 54 71.6557L53.2977 73.692C52.9231 73.5252 52.5745 73.39 52.252 73.2865C51.9294 73.1772 51.6068 73.1225 51.2843 73.1225C50.0461 73.1225 49.427 74.0946 49.427 76.0388C49.427 77.9255 50.0461 78.8689 51.2843 78.8689C51.7421 78.8689 52.1661 78.8027 52.5563 78.6704C52.9465 78.5324 53.3367 78.3195 53.7269 78.0319V80.2839C53.3419 80.5542 52.9517 80.7412 52.5563 80.8447C52.1661 80.9482 51.6719 81 51.0736 81Z",
    fill: "#E40E68"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 36V48L27.5 36L35.5 48L46 36L54 48L64 36L73 48L82.5 36V48",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 66L26 71.7735L26 60.2265L16 66ZM86 66L76 60.2265L76 71.7735L86 66ZM25 67L77 67L77 65L25 65L25 67Z",
    fill: "#E40E68"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 54L25 59.7735V48.2265L15 54ZM38 54L28 48.2265V59.7735L38 54ZM24 55H29V53H24V55Z",
    fill: "#005AE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEspiral);
export default __webpack_public_path__ + "static/media/espiral.5e4435fe41033230dc27bf9d9ebeb556.svg";
export { ForwardRef as ReactComponent };